module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs_dhx_material/export_pdf.png?9827ff3e26ad35bfaaedbfc6d70c3c2a";